/*
 * Module for the Notes Index page
*/

rs.module("framework/content/notes/index",

    ["common/select-helper", "controls/components/event-banner", "controls/data/grid"],

    function (selectHelper, eventBanner, gridModule) {

        //
        // Initialize
        //
        function initialize(lrsGridApi, jsSelectors, codeValues, backendUrls) {

            var form = $.js(jsSelectors.form);

            var executeSelectionChanged;

            // Listen for grid row selection
            lrsGridApi.selectionChanged(function (values, rows) {

                // This handler fires when the grid is first rendered, but we don't want it to in our case
                // executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                if (executeSelectionChanged && values.length > 0) {

                    _clearErrors();

                    // Retrieve the note for update
                    $.get(
                        backendUrls.getNote,
                        {
                            unidocAssocKey: values[0]
                        }
                    ).done(function (results) {

                        // populate input fields
                        selectHelper.getHelper(form.js(jsSelectors.typeSelect)).setValue(results.uniDocSubType.key);
                        form.js(jsSelectors.subject).val(results.description);
                        form.js(jsSelectors.note).val(results.uniDocText);
                        form.js(jsSelectors.terminationDate).val(results.terminationDate ? new Date(results.terminationDate).toISODateString() : null);

                        // populate hidden inputs
                        form.js(jsSelectors.unidocAssocKey).val(results.uniDocAssocKey);
                        form.js(jsSelectors.unidocKey).val(results.uniDocKey);
                        form.js(jsSelectors.effectiveDate).val(results.effectiveDate);
                        form.js(jsSelectors.enteredDate).val(results.enteredDate);
                        form.js(jsSelectors.enteredBy).val(results.enteredBy);
                        form.js(jsSelectors.enteredByName).val(results.enteredByName);
                        form.js(jsSelectors.updateToken).val(results.updateToken);
                    });
                }

                executeSelectionChanged = true;
            });

            // Update the grid when the include expired notes filter is toggled
            form.js(jsSelectors.includeExpiredNotesCheckbox).change(function () {

                form.js(jsSelectors.loadingSpinner).show();

                gridModule.update(
                    backendUrls.getNotesList,
                    {
                        includeExpiredNotes: $(this).is(":checked")
                    },
                    lrsGridApi.agGridApi,
                    function done() {
                        form.js(jsSelectors.loadingSpinner).hide();

                        // if there is at least one row to display after filtering, select the first one
                        if (lrsGridApi.agGridApi.getDisplayedRowCount() > 0) {
                            lrsGridApi.selectFirstRow();
                        }
                    }
                );
            });

            // on add link click, clear grid selection and reset all fields and hidden inputs for a new note
            $.js(jsSelectors.addLink).click(function () {

                lrsGridApi.selectedValues = null;

                _resetForm();
            });

            // on cancel button click, reset form back to it's state prior to adding/editing
            $.js(jsSelectors.cancelButton).click(function () {

                // If the user was editing an existing note...
                if (form.js(jsSelectors.unidocAssocKey).val() != -1) {

                    _clearErrors();

                    // Re-retrieve the note
                    $.get(
                        backendUrls.getNote,
                        {
                            unidocAssocKey: form.js(jsSelectors.unidocAssocKey).val()
                        }
                    ).done(function (results) {

                        // populate input fields
                        selectHelper.getHelper(form.js(jsSelectors.typeSelect)).setValue(results.uniDocSubType.key);
                        form.js(jsSelectors.subject).val(results.description);
                        form.js(jsSelectors.note).val(results.uniDocText);
                        form.js(jsSelectors.terminationDate).val(results.terminationDate ? new Date(results.terminationDate).toISODateString() : null);

                        // populate hidden inputs
                        form.js(jsSelectors.unidocAssocKey).val(results.uniDocAssocKey);
                        form.js(jsSelectors.unidocKey).val(results.uniDocKey);
                        form.js(jsSelectors.effectiveDate).val(results.effectiveDate);
                        form.js(jsSelectors.enteredDate).val(results.enteredDate);
                        form.js(jsSelectors.enteredBy).val(results.enteredBy);
                        form.js(jsSelectors.enteredByName).val(results.enteredByName);
                        form.js(jsSelectors.updateToken).val(results.updateToken);
                    });
                }
                // If the user was adding a new note...
                else {

                    _resetForm();

                    lrsGridApi.selectFirstRow();
                }
            });

            //
            // Reset form inputs and hidden fields
            //
            function _resetForm() {

                _clearErrors();

                // reset input fields
                selectHelper.getHelper(form.js(jsSelectors.typeSelect)).setValue(codeValues.summary);
                form.js(jsSelectors.subject).val(null);
                form.js(jsSelectors.note).val(null);
                form.js(jsSelectors.terminationDate).val(null);

                // reset hidden inputs
                form.js(jsSelectors.unidocAssocKey).val(-1);
                form.js(jsSelectors.unidocKey).val(-1);
                form.js(jsSelectors.effectiveDate).val(null);
                form.js(jsSelectors.enteredDate).val(null);
                form.js(jsSelectors.enteredBy).val(0);
                form.js(jsSelectors.enteredByName).val(null);
                form.js(jsSelectors.updateToken).val(null);
            }

            //
            // Clear event banner and field errors
            //
            function _clearErrors() {

                // clear event banner
                eventBanner.removeAllMessages();

                // clear field errors
                form.js(jsSelectors.typeSelect).clearErrors();
                form.js(jsSelectors.subject).clearErrors();
                form.js(jsSelectors.note).clearErrors();
                form.js(jsSelectors.terminationDate).clearErrors();
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);